// extracted by mini-css-extract-plugin
module.exports = {"newPathHero":"style-module--newPathHero--2W24A"};